module.exports = __webpack_public_path__ + "static/kamil_drazkiewicz-2d36b68094e9e4ed786ffccf7f3d53d1.png";